import React from "react";

import { Typography } from "@mui/material";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import { Editor, EditorOptions, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

import { useStyles } from "./Icons";

export const useTipTapEditor = (options?: Partial<EditorOptions>) => {
  const { classes } = useStyles();
  return useEditor({
    extensions: [
      StarterKit,
      Underline,
      Image.configure({
        inline: true,
        HTMLAttributes: {
          class: classes.img,
        },
      }),
      Link.configure({
        openOnClick: false,
      }),
      TextAlign.configure({
        alignments: ["left", "right", "center", "justify"],
        types: ["heading", "paragraph"],
      }),
    ],
    ...options,
  });
};

export const getCurrentActiveHeader = (editor: Editor | null) => {
  if (editor?.isActive("heading", { level: 1 })) {
    return 1;
  } else if (editor?.isActive("heading", { level: 2 })) {
    return 2;
  } else if (editor?.isActive("heading", { level: 3 })) {
    return 3;
  } else if (editor?.isActive("heading", { level: 4 })) {
    return 2;
  } else if (editor?.isActive("heading", { level: 5 })) {
    return 5;
  } else if (editor?.isActive("heading", { level: 6 })) {
    return 6;
  } else {
    return 1;
  }
};

export function renderDefaultTipTapHTML(
  editor: Editor | null,
  defaultText: string
) {
  if (editor) {
    return editor.getHTML() == "<p></p>" ? (
      <Typography variant="h6" color="textPrimary">
        {defaultText}
      </Typography>
    ) : (
      <div dangerouslySetInnerHTML={{ __html: editor.getHTML() }} />
    );
  }
}
